import React, { useEffect, useState } from 'react';
import api from '../api';

const WhatsAppButton = () => {
  const [phone, setPhone] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    api.get('/api/settings')
      .then(({ data }) => {
        const num = data.data.whatsapp_number;
        if (num) {
          setPhone(num.replace(/\s|\+|-/g, ''));
          setTimeout(() => setVisible(true), 1500);
        }
      })
      .catch(() => {});
  }, []);

  if (!phone) return null;

  const message = encodeURIComponent('Bonjour, je suis intéressé par vos produits 👋');
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Contactez-nous sur WhatsApp"
      style={{
        position: 'fixed',
        bottom: '1.5rem',
        right: '1.5rem',
        zIndex: 999,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: '#25D366',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(37,211,102,0.45)',
        opacity: visible ? 1 : 0,
        transform: visible ? 'scale(1)' : 'scale(0.5)',
        transition: 'opacity .4s ease, transform .4s ease',
        textDecoration: 'none',
      }}
    >
      {/* WhatsApp SVG icon */}
      <svg viewBox="0 0 32 32" width="30" height="30" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.469 2.027 7.77L0 32l8.44-2.01A15.94 15.94 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.747-1.84l-.484-.287-5.01 1.194 1.24-4.88-.317-.5A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.87c-.398-.199-2.354-1.162-2.719-1.294-.365-.133-.631-.199-.897.199-.265.398-1.03 1.294-1.263 1.56-.232.265-.465.298-.863.1-.398-.2-1.68-.619-3.2-1.974-1.183-1.055-1.981-2.358-2.213-2.756-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.698.199-.232.265-.398.398-.663.133-.266.066-.499-.033-.698-.1-.2-.897-2.162-1.23-2.96-.323-.778-.652-.673-.897-.685l-.764-.013c-.265 0-.696.1-1.061.499-.365.398-1.394 1.362-1.394 3.323 0 1.961 1.427 3.857 1.626 4.123.199.265 2.808 4.287 6.805 6.013.951.41 1.693.655 2.271.839.954.304 1.823.261 2.51.158.765-.114 2.354-.962 2.686-1.89.332-.929.332-1.726.232-1.89-.099-.166-.365-.265-.763-.465z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
